import { gettext } from '@eventbrite/i18n';
import { getCurrencySymbol } from '@eventbrite/intl';
import React from 'react';
import { useEnvContext } from '../../../../context';
import PlaceholderImage from '../../../../static/images/no_image_nearby_poi.svg';
import { NearbyPOIShape } from '../../../../types/AppProps';
import {
    imageContainerStyles,
    ImageShadowCaption,
} from '../ImageShadowCaption';
import styles from './NearbyPOICard.module.scss';

export interface NearbyPOICardProps extends Partial<NearbyPOIShape> {
    children?: React.ReactChild;
}

export const NearbyPOICard = (props: NearbyPOICardProps) => {
    const { name, photos, children, url, html_attributions } = props;
    const SHOULD_DISPLAY_CARD = name && url;

    const GOOGLE_PHOTO_URL = photos?.at(0) || PlaceholderImage;
    const GOOGLE_PHOTO_HTML_ATTRIBUTIONS = html_attributions?.at(0);

    return SHOULD_DISPLAY_CARD ? (
        <div className={styles.nearbyPOICard}>
            <a href={url} className={styles.nearbyPOICardLink}>
                <div
                    className={`${styles.nearbyPOICardImageContainer} ${imageContainerStyles.imageContainer}`}
                >
                    <img
                        className={`${styles.nearbyPOICardImage} ${imageContainerStyles.image}`}
                        src={GOOGLE_PHOTO_URL}
                        data-testid="nearbyPOI__image"
                    />

                    {GOOGLE_PHOTO_HTML_ATTRIBUTIONS ? (
                        <ImageShadowCaption
                            captionContainerClass={
                                styles.nearbyPOICardImageCaptionBorderRadius
                            }
                        >
                            <>
                                Photo From{' '}
                                <span
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{
                                        __html: GOOGLE_PHOTO_HTML_ATTRIBUTIONS,
                                    }}
                                ></span>
                            </>
                        </ImageShadowCaption>
                    ) : (
                        ''
                    )}
                </div>

                <p className={styles.nearbyPOICardName}>{name}</p>
                {children}
            </a>
        </div>
    ) : null;
};

// TODO: Will be implemented in a fast follow
export const EventsLink = ({
    startingCost,
}: {
    startingCost: string | number;
}) => {
    const { env } = useEnvContext();

    const CURRENCY_SYMBOL =
        getCurrencySymbol(env?.localeInfo.default_currency) || '$';
    const PRICING_DATA = CURRENCY_SYMBOL + String(startingCost);

    const LINK_TEXT = gettext('Events from %(startingCost)s', {
        startingCost: PRICING_DATA,
    });

    return (
        <div
            data-testid="nearbyPOI__event-starting-cost"
            className={styles.eventsLink}
        >
            {LINK_TEXT}
        </div>
    );
};
